import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconTrash from '@/icons/Trash.svg';

export const RequestMediumDeletedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'request_medium_deleted'>;
}) => {
  const creatorName = activity.creator?.name ?? '';

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      icon={<IconTrash />}
      type="danger"
      message={
        <BaseActivityText>
          <Trans id="activities.request_medium_deleted.message">
            <strong>{creatorName}</strong> deleted a medium from the request
          </Trans>
        </BaseActivityText>
      }
    />
  );
};
